// Turning on our mail for a domain: POST /emails/domains. The API only accepts a name the
// customer has with us (a domain or a hosting), so the candidates come from those two lists.
import { get, post } from '../../lib/api.js';
import { errorMessage } from '../../lib/errors.js';
import { t } from '../../lib/i18n.jsx';

export async function mailDomainCandidates() {
  const [domains, hostings, mailDomains] = await Promise.all([
    get('/dns/domains').catch(() => []),
    get('/hostings').catch(() => []),
    get('/emails/domains').catch(() => []),
  ]);
  const taken = new Set((mailDomains || []).map((m) => m.domain.toLowerCase()));
  const byName = new Map();
  for (const h of hostings || []) {
    const name = (h.domain || '').toLowerCase();
    if (name && !taken.has(name)) byName.set(name, { name, hostingId: h.id });
  }
  for (const d of domains || []) {
    const name = (d.domain_name || '').toLowerCase();
    if (name && !taken.has(name) && !byName.has(name)) byName.set(name, { name, hostingId: d.hosting_id || null });
  }
  return [...byName.values()].sort((a, b) => a.name.localeCompare(b.name));
}

export function activateMail(name, hostingId) {
  return post('/emails/domains', { domain: name, ...(hostingId ? { hosting_id: hostingId } : {}) });
}

export function activateMailError(err, lang) {
  const code = err?.payload?.detail?.code;
  if (code === 'domain_not_owned') return t(lang, 'mailDomain.err.notOwned');
  if (err?.status === 409) return t(lang, 'mailDomain.err.exists');
  return errorMessage(err, { lang });
}
